module.exports = __webpack_public_path__ + "static/media/playlist-play-circle.547f75da.svg";